import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
});

// Devuelve los ms que quedan hasta que expira el token JWT
function msHastaExpiracion(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 - Date.now();
  } catch {
    return 0;
  }
}

let renovando = false;

api.interceptors.request.use(async config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;

    // Si queda menos de 1 hora, renovar silenciosamente
    const UNA_HORA = 60 * 60 * 1000;
    if (!renovando && msHastaExpiracion(token) < UNA_HORA) {
      renovando = true;
      try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/renovar`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const nuevoToken = res.data.token;
        localStorage.setItem('token', nuevoToken);
        config.headers.Authorization = `Bearer ${nuevoToken}`;
      } catch {
        // Si falla la renovación no interrumpimos la request actual
      } finally {
        renovando = false;
      }
    }
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    const esLoginPropio = error.config?.url?.includes('/auth/login');
    if (error.response?.status === 401 && !esLoginPropio) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
